const defaultMs = 400;

export default defaultMs;
